module.exports = __webpack_public_path__ + "img/15@3x.0a5cd200.png";